import { LogEventService } from './../logevent/logeventservice';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AlertService, AuthenticationService, UserService } from '../_services';
import { AppComponent } from '../app.component';
import { Logevent } from '../logevent/logevent';

@Component({
    templateUrl: 'login.component.html',
    styleUrls: ['login.component.less', '../app.component.less'
    ]
})
export class LoginComponent implements OnInit {
    loginForm: FormGroup;
    loading = false;
    submitted = false;
    returnUrl: string;
    isCollapsed = false;
    releaseVersion: string = environment.releaseVersion;


    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private alertService: AlertService,
        private appcomponenet: AppComponent,
        private userservice: UserService,
        private logservice: LogEventService) { }


    ngOnInit() {

        this.loginForm = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });

        // reset login status
      this.authenticationService.logout();
        this.appcomponenet.updateUser();

        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/dashboard';

        if (this.userservice.getCurrentUserFromCookie() != null) {
            this.router.navigate([this.returnUrl]);
        }
    }

    // convenience getter for easy access to form fields
    get f() { return this.loginForm.controls; }

    onSubmit() {

this.submitted = true;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
        this.logservice.logEvent(0,'Login Attempt', {
            username: this.f.username.value,
            success: false,
            reason: 'Form is invalid'
        });
        return;
    }

    this.authenticationService.login(this.f.username.value, this.f.password.value)
        .pipe(first())
        .subscribe(
            data => {
                // Log successful login
                this.router.navigate([this.returnUrl]);
            },
            error => {
                // Log failed login attempt
                this.logservice.logEvent(0,'Login Attempt', {
                    username: this.f.username.value,
                    success: false,
                    reason: 'Incorrect username or password'
                });

                window.alert("Incorrect username or password. Please try again or contact the administration for assistance.");
                this.alertService.error(error);
            }
        );

    }
    forgotPassword() {
        this.authenticationService.forgotPass(this.f.username.value);
    }
}
